<template>
    <div :style="`height: ${height};`">
        <apexchart height="100%" width="100%" type="area" :options="options" :series="series"/>
    </div>
</template>

<script>
export default {
    props: {
        series: [Object, Array],
        height: {
            type: String,
            default: '400px',
        },
        yAxis: {
            type: String,
            default: '',
        },
        colors: {
            type: Array,
            default: () => {
                return ['#9881F6', '#8a8a8a', '#3e9c4e', '#b31e19', '#2819b3'];
            },
        },
    },

    data() {
        return {
            options: {
                xaxis: {
                    type: "datetime",
                    tickPlacement: 'between',
                    labels: {
                        formatter: function (value, timestamp) {
                            const date = new Date(timestamp);
                            return new Intl.DateTimeFormat('de-DE', {
                                day: '2-digit',
                                month: 'short',
                            }).format(date);
                        },
                    },
                },
                stroke: {
                    curve: 'smooth',
                    width: 2,
                },
                markers: {
                    size: 1,
                },
                zoom: {
                    enable: false,
                },
                fill: {
                    colors: this.colors,
                    opacity: 0.5,
                    type: 'gradient',
                },
                colors: this.colors,
                dataLabels: {
                    enabled: true,
                },
                legend: {
                    show: true,
                    position: 'bottom',
                    offsetY: 10,
                },
            },
        };
    },
};
</script>
